import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight } from '@mui/icons-material';

interface Props {
  collapsed: boolean;
  onToggle: () => void;
}

const Row = styled('div', {
  shouldForwardProp: p => p !== 'collapsed',
})<{ collapsed: boolean }>(({ collapsed }) => ({
  display: 'flex',
  justifyContent: collapsed ? 'center' : 'flex-end',
  padding: '4px 8px',
  flexShrink: 0,
}));

const Btn = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 6,
  border: 'none',
  borderRadius: 6,
  background: 'transparent',
  cursor: 'pointer',
  color: theme.tokens.fgTertiary,
  transition: 'background 120ms ease, color 120ms ease',
  '& .MuiSvgIcon-root': { fontSize: 20, color: 'inherit' },
  '&:hover': {
    backgroundColor: theme.tokens.sidebarItemHover,
    color: theme.tokens.fgPrimary,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.tokens.accent}`,
    outlineOffset: 2,
  },
}));

export default function SidebarCollapse({ collapsed, onToggle }: Props) {
  return (
    <Row collapsed={collapsed}>
      <Tooltip title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'} placement="top">
        <Btn onClick={onToggle} aria-label="Toggle sidebar">
          {collapsed ? <KeyboardDoubleArrowRight /> : <KeyboardDoubleArrowLeft />}
        </Btn>
      </Tooltip>
    </Row>
  );
}
